import React from 'react'
import { IssueEntity } from 'types/IssueEntity'
import { formatDateYYYYMMDD } from '../../../packages/utils/numberFormatters'
import { FactsTableRow } from '../../components/FactsTable'

export function PublicationDateRow({ issue }: { issue: IssueEntity }) {
    const publicationDate = issue.sources?.find((s) => s.sourceType === 'Publication')?.publishedDate

    return <FactsTableRow label='Datum (avisering)'>{formatDateYYYYMMDD(publicationDate)}</FactsTableRow>
}
